import { render } from "./terms-nav.vue?vue&type=template&id=5c631ff9&ts=true"
import script from "./terms-nav.vue?vue&type=script&lang=ts"
export * from "./terms-nav.vue?vue&type=script&lang=ts"

import "./terms-nav.vue?vue&type=style&index=0&id=5c631ff9&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__